import { render, staticRenderFns } from "./TicketAiInfo.vue?vue&type=template&id=4e798d02&scoped=true"
import script from "./TicketAiInfo.vue?vue&type=script&lang=js"
export * from "./TicketAiInfo.vue?vue&type=script&lang=js"
import style0 from "./TicketAiInfo.vue?vue&type=style&index=0&id=4e798d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e798d02",
  null
  
)

export default component.exports